// minimal "empty" data source for a mapbox gl layer to not show anything
const EMPTY_SOURCE_DATA = {
    type: 'Point',
    coordinates: [],
};

module.exports = {
    EMPTY_SOURCE_DATA,
};
